<div class="container">
    <form>
        <div class="row">
            <div class="col-md-4">
                <label for="motivoId" class="form-label">Motivo de la cancelación*</label>
                <select id="motivoId" class="form-select" aria-label="Default select example" name="motivoId"
                    [(ngModel)]="dataCancelar.MotivoCancelacionId" (change)="onSelect()" #MotivoCancelacionId="ngModel" required>
                    <option selected disabled>Seleccionar</option>
                    <option *ngFor="let option of this.$parametricList.typeCancellationsList"
                        [value]="option.idParametroDetalle">
                        {{option.vcNombre}}
                    </option>
                </select>

                <strong class="invalid-feedback d-block"
                    *ngIf="MotivoCancelacionId.invalid && (MotivoCancelacionId.dirty || MotivoCancelacionId.touched)">
                    <span *ngIf="MotivoCancelacionId.errors?.['required']">
                        Campo obligatorio
                    </span>
                </strong>
            </div>

            <div class="col-md-4">
                <label for="ids" class="form-label">ID Asociado</label>
                <input id="ids" type="text" class="form-control" [value]="dataTableSolicitud.id" name="id" disabled>
            </div>
        </div>

        <br>

        <div class="row">
            <div class="col-12">
                <label for="" class="form-label">Justificación*</label>
                <textarea class="form-control" rows="2" maxlength="800" name="justificacion"
                    [(ngModel)]="dataCancelar.TxtObservacion" #TxtObservacion="ngModel" required>
                </textarea>

                <strong class="invalid-feedback d-block"
                    *ngIf="TxtObservacion.invalid && (TxtObservacion.dirty || TxtObservacion.touched)">
                    <span *ngIf="TxtObservacion.errors?.['required']">
                        Campo obligatorio
                    </span>
                    <span *ngIf="TxtObservacion.errors?.['maxlength']">
                        Máximo 800 caracteres
                    </span>
                </strong>
            </div>
        </div>
    </form>

    <br>

    <div class="container overflow-auto" *ngIf="solicitudSeleccionada.id">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th scope="col">ID solicitud</th>
                    <th scope="col">Referente que solicitó el servicio</th>
                    <th scope="col">Fecha de solicitud</th>
                    <th scope="col">Nombre del Directivo</th>
                    <th scope="col">Motivo de cancelación</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{dataTableSolicitud.id}}</td>
                    <td>{{dataTableSolicitud.referenteSolicitud}}</td>
                    <td>{{dataTableSolicitud.fechaSolicitud}}</td>
                    <td>{{dataTableSolicitud.nombreDirectivo}}</td>
                    <td>{{dataTableSolicitud.motivo}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="container overflow-auto" *ngIf="solicitudDisponibleSeleccionada.id">
        <table class="table table-bordered text-center">
            <thead>
                <tr>
                    <th scope="col">ID solicitud</th>
                    <th scope="col">Trayecto</th>
                    <th scope="col">Origen</th>
                    <th scope="col">Destino</th>
                    <th scope="col">Hora salida</th>
                    <th scope="col">Hora llegada</th>
                    <th scope="col">Fecha solicitud del servicio</th>
                    <th scope="col">Fecha de prestación del servicio</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Motivo de cancelación</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{dataTableSolicitud.id}}</td>
                    <td>{{dataTableSolicitud.vcTrayecto}}</td>
                    <td>{{dataTableSolicitud.vcLugarSalida}} </td>
                    <td>{{dataTableSolicitud.vcLugarDestino}} </td>
                    <td>{{dataTableSolicitud.dtHoraSalida}} </td>
                    <td>{{dataTableSolicitud.dtHoraRegreso}} </td>
                    <td>{{dataTableSolicitud.dtFechaSolicitud}} </td>
                    <td>{{dataTableSolicitud.dtFechaPrestacionServicio}} </td>
                    <td>{{dataTableSolicitud.vcEstado}} </td>
                    <td>{{dataTableSolicitud.motivo}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <br>

    <div class="d-flex flex-row-reverse">
        <div class="col-md-3 px-2">
            <button class="btn btn-secondary col-md-12" type="button" 
                (click)="actionWarning('¿Esta seguro de cerrar y salir del proceso de cancelación de la solicitud de servicio?', 'cerrar')">
                CERRAR
            </button>
        </div>

        <div class="col-md-3 px-2">
            <button class="btn btn-secondary col-md-12" type="submit" 
                [disabled]="MotivoCancelacionId.invalid || TxtObservacion.invalid" 
                (click)="actionWarning('¿Esta seguro de cancelar la solicitud de servicio?', 'enviar')">
                    CANCELAR SOLICITUD
            </button>
        </div>
    </div>
</div>